/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer components {
  .highlightTimestampCursor {
    -webkit-user-select: none;
    user-select: none;
  }
}
